import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
  selector: "app-rewards-loyalty-points",
  templateUrl: "./rewards-loyalty-points.component.html",
  standalone:false,
  styleUrls: ["./rewards-loyalty-points.component.scss"],
})
export class RewardsLoyaltyPointsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

   carouselOptions: OwlOptions = {
    loop: false,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };
  totalslidervalues: string[] = [];

  constructor(private location: Location, private router: Router) {}

  ngOnInit(): void {}
  selectedCard: number = 0;
  selectCard(e) {
    const index = this.resolveCardIndex(e);
    if (index != null) {
      this.selectedCard = index;
    }
  }

  /**
   * Resolves the slide index from either an owl-carousel-o event payload
   * (SlidesOutputData: { startPosition, slides }) or a plain index passed by
   * internal callers such as selectCard(0).
   */
  private resolveCardIndex(e): number {
    if (typeof e === "number") {
      return e;
    }
    if (e && typeof e.startPosition === "number") {
      return e.startPosition;
    }
    return null;
  }
  showModal(num) {
    this.modalObservable.next(num);
  }
  loyaltyPointsRadeem() {
    this.router.navigateByUrl("/LoyaltyPointsRadeem");
  }
}

